import { Duration } from 'luxon';
import { interval, Observable } from 'rxjs';
import { filter, map, startWith, take } from 'rxjs/operators';
interface CountdownOptions {
  tickDuration?: number;
  emitZero?: boolean;
  emitInitial?: boolean;
}

export function countdown(
  ticks: number,
  options: CountdownOptions = {}
): Observable<number> {
  const tickDuration = options.tickDuration ?? 1000;
  const emitZero = options.emitZero ?? true;
  const emitInitial = options.emitInitial ?? true;

  const countdown$ = interval(tickDuration).pipe(
    take(ticks),
    map((n) => ticks - 1 - n),
    filter((value) => emitZero || value !== 0)
  );

  if (emitInitial) return countdown$.pipe(startWith(ticks));
  else return countdown$;
}

const dateFormats: { [key: string]: string } = {
  'en-US': 'MM/dd/yyyy',
  'en-GB': 'dd/MM/yyyy',
  'en-AU': 'dd/MM/yyyy',
  'fr-FR': 'dd/MM/yyyy',
  // Add other locale mappings as needed
};

export const dateFormatByLocale = (locale: string) => {
  return dateFormats[locale] || 'dd/MM/yyyy';
};

export const humanReadableDuration = (duration: Duration) => {
  if (!duration) {
    return null;
  }
  const roundedMinutes = Math.ceil(duration.as('minutes'));
  // Convert the rounded minutes back to a Duration
  const roundedDuration = Duration.fromObject({ minutes: roundedMinutes });
  // Format based on whether it's under or over 60 minutes
  const humanReadable =
    roundedMinutes < 60
      ? roundedDuration.toHuman({ unitDisplay: 'short' }) // e.g., "45 minutes"
      : roundedDuration
          .shiftTo('hours', 'minutes')
          .toHuman({ unitDisplay: 'short' }); // e.g., "1 hr, 2 min"

  return humanReadable;
};
